/* @flow */
import cx from 'classnames';
import * as React from 'react';

import './SchoolViewSection.scss';

type Props = {
  angle?: boolean,
  children: React.Node,
  className?: string,
  theme?: 'light' | 'dark',
};

export default function SchoolViewSection({ angle, children, className, theme }: Props) {
  return (
    <section
      className={cx(
        'SchoolViewSection',
        angle && 'SchoolViewSection--angle',
        theme && `SchoolViewSection--${theme}`,
        className
      )}>
      {children}
    </section>
  );
}

SchoolViewSection.defaultProps = {
  angle: true,
  theme: 'light',
};
